import { createContext, useContext, useState, useEffect } from "react";

const FontSizeContext = createContext();

export function FontSizeProvider({ children }) {
    const [fontScale, setFontScale] = useState(1); // Default scale 100%
    const [selectedTextSize, setSelectedTextSize] = useState("Regular"); // Store selected size

    useEffect(() => {
        document.documentElement.style.setProperty("--font-scale", fontScale);
    }, [fontScale]);

    return (
        <FontSizeContext.Provider value={{ fontScale, setFontScale, selectedTextSize, setSelectedTextSize }}>
            {children}
        </FontSizeContext.Provider>
    );
}

// Custom Hook to Use Context
export function useFontSize() {
    return useContext(FontSizeContext);
}